import { all } from 'typed-redux-saga'
import { orderEditSaga } from './orderEdit'
import { ordersListSaga } from './ordersList'
import { documentsSaga } from './documents'
import { productsSaga } from './products'
import { tariffsSaga } from './tariffs'
import { okvedsSaga } from './okveds'
import { infotecsSaga } from './infotecs'
import { fnsSaga } from './fns'
import { drsSaga } from './drs'
import { sberGeoAddressSaga } from './sberGeoAddress'
import { commonPatentsSaga, transportPatentsSaga, realtyPatentsSaga } from './patents'
import { outOfficeRegistratorCabinetSaga } from './outOfficeRegistratorCabinet'

export function* registratorCabinetSagas() {
	yield* all([
		ordersListSaga(),
		orderEditSaga(),
		documentsSaga(),
		productsSaga(),
		tariffsSaga(),
		okvedsSaga(),
		infotecsSaga(),
		fnsSaga(),
		drsSaga(),
		sberGeoAddressSaga(),
		commonPatentsSaga(),
		transportPatentsSaga(),
		realtyPatentsSaga(),
		outOfficeRegistratorCabinetSaga(),
	])
}
